import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(() => ({
  root: {
    width: '100%',
    maxHeight: 39,
    '& .MuiOutlinedInput-root': {
      maxHeight: 39,
    },
  },
}));